// extracted by mini-css-extract-plugin
module.exports = {"main":"Input_main__1RGjw","input_box":"Input_input_box__29ld7","bubble":"Input_bubble__3QJAL","error_text":"Input_error_text__3sSVb","error":"Input_error__46U7S"};